import prismicDOM from 'prismic-dom';
const Elements = prismicDOM.RichText.Elements;

/**
 * Html Serializer helper for Prismic projects.
 * 
 * @since 0.0.3 
 * 
 * @param {Function} linkResolver 
 * @param type
 * @param element 
 * @param content 
 * @param children
 */
export default (linkResolver, type, element, content, children) => {

    // Should be set through env file 
    const appUrl = process.env.APP_URL;

    if(type === Elements.hyperlink) {

        if(element.data.link_type === 'Document') {
            const url = prismicDOM.Link.url(element.data, linkResolver)
            return `<a href="${url}" data-nuxt-link>${content}</a>`;
        }
        else if(typeof appUrl !== 'undefined' && 
                element.data.link_type === 'Web' && 
                element.data.url.startsWith(appUrl)) {

            let url = element.data.url.replace(process.env.APP_URL, '');
            if(!url.startsWith('/')) url = `/${url}`;
            if(!url.endsWith('/')) url = `${url}/`;
            
            return `<a href="${url}" data-nuxt-link>${content}</a>`;
        }

    }

    // return null to stick with default behaviour 
    return null;

};